const throttle = (f: (args: any[]) => any, delay: number) => {
  let timer = 0;
  return function(...args: [args: any[]]) {
      clearTimeout(timer);
      // @ts-ignore
      timer = Number(setTimeout(() => f.apply(this, args), delay));
  }
}

export default throttle;